export enum AssessmentStatus {
  Draft = 0,
  Active = 1,
  Closed = 2,
  Archived = 3,
  Scheduled = 4,
}

export enum AssessmentStatusDescription {
  Draft = 'Draft',
  Active = 'Active',
  Closed = 'Closed',
  Archived = 'Archived',
  Scheduled = 'Scheduled',
}

